import { IconExit, IconUserCircle } from '@douyinfe/semi-icons';
import { Avatar, Button, Dropdown, Space, Typography } from '../ui/semi';

interface AccountMenuProps {
  name: string;
  caption: string;
  initials: string;
  onOpenProfile?: () => void;
  onLogout: () => void;
}

export function AccountMenu({ name, caption, initials, onOpenProfile, onLogout }: AccountMenuProps) {
  return (
    <Dropdown
      trigger="click"
      position="bottomRight"
      contentClassName="account-dropdown-surface"
      closeOnEsc
      render={(
        <Dropdown.Menu className="account-dropdown-menu">
          <Dropdown.Title className="account-menu-summary">
            <Typography.Text strong>{name}</Typography.Text>
            <Typography.Text type="secondary">{caption}</Typography.Text>
          </Dropdown.Title>
          <Dropdown.Divider />
          {onOpenProfile && <Dropdown.Item icon={<IconUserCircle />} onClick={onOpenProfile}>个人中心</Dropdown.Item>}
          {onOpenProfile && <Dropdown.Divider />}
          <Dropdown.Item type="danger" icon={<IconExit />} onClick={onLogout}>退出登录</Dropdown.Item>
        </Dropdown.Menu>
      )}
    >
      <Button theme="borderless" className="account-trigger" aria-label={`打开 ${name} 的账户菜单`}>
        <Space spacing={10}>
          <Avatar size="small">{initials}</Avatar>
          <span className="account-trigger-copy">
            <Typography.Text strong>{name}</Typography.Text>
            <Typography.Text type="secondary">{caption}</Typography.Text>
          </span>
        </Space>
      </Button>
    </Dropdown>
  );
}
